import BucketApiRequest from "./BucketApiRequest";
import { GET_COUNTRIES_TAX_LIST } from "../ApiUrls";

export default class GetCountriesTaxList extends BucketApiRequest {
  getUrl = () => {
    return GET_COUNTRIES_TAX_LIST;
  };
}
